module.exports = __webpack_public_path__ + "static/img/product_6.1e1e8a56.png";